import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  saveSuccessTitle: {
    description: 'Title for successful template save notification',
    defaultMessage: 'Template Saved',
    id: 'VQkM4s',
  },
  saveSuccessMessage: {
    description: 'Message for successful template save notification',
    defaultMessage: 'Your template has been saved successfully.',
    id: 'iqJFB1',
  },
  saveErrorTitle: {
    description: 'Title for failed template save notification',
    defaultMessage: 'Save Failed',
    id: 'yGP2V1',
  },
  saveErrorMessage: {
    description: 'Message for failed template save notification',
    defaultMessage: 'Unable to save template. Please try again.',
    id: 'vx1gxr',
  },
  resetSuccessTitle: {
    description: 'Title for successful template reset notification',
    defaultMessage: 'Default Template Loaded',
    id: '3jv2wG',
  },
  resetSuccessMessage: {
    description: 'Message for successful template reset notification',
    defaultMessage: 'The default template has been loaded successfully.',
    id: '7iwmjT',
  },
  resetErrorTitle: {
    description: 'Title for failed template reset notification',
    defaultMessage: 'Load Failed',
    id: 'k99W9q',
  },
  resetErrorMessage: {
    description: 'Message for failed template reset notification',
    defaultMessage: 'Unable to load default template. Please try again.',
    id: 'EaPBm9',
  },
});
